import { render } from "./banner.vue?vue&type=template&id=baa122aa&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=baa122aa&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa122aa"]])

export default __exports__